import React, { ReactNode } from "react";

import "./PauseInternetLabel.scss";

interface PauseInternetLabelProps {
  children: ReactNode;
}

export const PauseInternetLabel = ({ children }: PauseInternetLabelProps) => {
  return <div className="pause-internet-label">{children}</div>;
};
